import { createSelector } from '@reduxjs/toolkit'

import { getAML } from '../root.selectors'

export const getAMLUnslUsers = createSelector(getAML, (slice) => slice.unslUsers)
export const getAMLZoneUsers = createSelector(getAML, (slice) => slice.zoneUsers)
export const getAMLExternals = createSelector(getAML, (slice) => slice.externals)
export const getAMLRiskOperations = createSelector(getAML, (slice) => slice.riskOperations)
export const getAMLAlerts = createSelector(getAML, (slice) => slice.alerts)
export const getAMLCRA = createSelector(getAML, (slice) => slice.cra)
export const getAMLRiskLevels = createSelector(getAML, (slice) => slice.riskLevels)
